import { GHLLanguageKeys as e } from "./ghl-ui.es273.js";
const r = {
  name: e.norwegian,
  global: {
    undo: "Angre",
    redo: "Gjør om",
    confirm: "Gjør om",
    clear: "Gjør om",
    more: "mer",
    cancel: "Kansellere"
  },
  Popconfirm: {
    positiveText: "Bekreft",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "Vennligst Velg",
    loading: "Laster",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM.yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Tøm",
    now: "Nå",
    confirm: "Bekreft",
    selectTime: "Velg Tid",
    selectDate: "Velg Dato",
    datePlaceholder: "Velg Dato",
    datetimePlaceholder: "Velg Dato og Tid",
    monthPlaceholder: "Velg Måned",
    yearPlaceholder: "Velg År",
    quarterPlaceholder: "Velg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slutt Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slutt Dato og Tid",
    startMonthPlaceholder: "Start Måned",
    endMonthPlaceholder: "Slutt Måned",
    monthBeforeYear: !0,
    firstDayOfWeek: 0,
    today: "I Dag"
  },
  DataTable: {
    checkTableAll: "Velg alle i tabellen",
    uncheckTableAll: "Fjern markeringen av alle i tabellen",
    confirm: "Bekreft",
    clear: "Tøm",
    apply: "Bruk",
    filters: "Filtere",
    sort: "Sortere"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "Mål"
  },
  Transfer: {
    selectAll: "Marker alle",
    unselectAll: "Fjern alle valg",
    clearAll: "Tøm"
  },
  Empty: {
    description: "Ingen Data"
  },
  Select: {
    placeholder: "Vennligst Velg"
  },
  TimePicker: {
    placeholder: "Velg Tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "Nå"
  },
  Pagination: {
    goto: "Gå til",
    selectionSuffix: "side",
    next: "Neste",
    previous: "Forrige"
  },
  DynamicTags: {
    add: "Legg tid"
  },
  Log: {
    loading: "Laster"
  },
  Input: {
    placeholder: "Vennligst Skriv Inn"
  },
  InputNumber: {
    placeholder: "Vennligst Skriv Inn"
  },
  DynamicInput: {
    create: "Opprett"
  },
  ThemeEditor: {
    title: "Tema Redigerer",
    clearAllVars: "Tøm Alle Variabler",
    clearSearch: "Tøm Søk",
    filterCompName: "Filtrer Komponentnavn",
    filterVarName: "Filtrer Variabelnavn",
    import: "Importer",
    export: "Eksporter",
    restore: "Tilbakestill til Standard"
  },
  Image: {
    tipPrevious: "Forrige bilde (←)",
    tipNext: "Neste bilde (→)",
    tipCounterclockwise: "Mot klokken",
    tipClockwise: "Med klokken",
    tipZoomOut: "Zoom ut",
    tipZoomIn: "Zoom inn",
    tipClose: "Lukk (Esc)",
    tipOriginalSize: "Zoom til original størrelse"
  },
  SortFilter: {
    heading: "Sorter og filtrer",
    sortHeading: "Sorter etter",
    newestFirst: "Nyeste først",
    oldestFirst: "Eldste først",
    ascending: "Økende",
    descending: "Synkende",
    aToZ: "A-Å",
    zToA: "Å-A",
    apply: "Bruk",
    clear: "Tøm",
    cancel: "Avbryt",
    filters: "Filtre"
  },
  IconPicker: {
    noMatchingFound: "Ingen matchende resultater funnet"
  }
};
export {
  r as no
};
